import React, { useEffect, useState, useCallback } from "react";
import SalonService from "../../services/SalonService";
import { FaStar, FaChevronRight, FaInfoCircle } from "react-icons/fa";
import ReviewItem from "./ReviewItem";
import "./Reviews.css";

export default function ReviewsCard({ salonUuid, onOpenAll }) {
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchSummary = useCallback(async () => {
        try {
            const res = await SalonService.getInAppReviewsSummary(salonUuid);
            setSummary(res.data);
        } catch (e) {
            console.error("Failed to fetch review summary", e);
        } finally {
            setLoading(false);
        }
    }, [salonUuid]);

    useEffect(() => {
        if (salonUuid) {
            fetchSummary();
        }
    }, [salonUuid, fetchSummary]);

    if (loading) return null;

    if (!summary || summary.reviewCount === 0) {
        return (
            <div className="empty-reviews-box">
                <FaInfoCircle className="me-2" /> No reviews yet. Be the first to rate!
            </div>
        );
    }

    return (
        <div className="premium-reviews-card shadow-sm">
            <div className="reviews-summary-header">
                <div className="avg-rating-box">
                    <span className="avg-rating-value">
                        {summary.avgRating ? Number(summary.avgRating).toFixed(1) : "-"}
                    </span>
                    <div className="stars-small">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <FaStar key={i} className={i <= Math.round(summary.avgRating) ? "star-filled" : "star-empty"} />
                        ))}
                    </div>
                    <span className="review-count-text">{summary.reviewCount} Reviews</span>
                </div>

                <div className="star-distribution">
                    {[5, 4, 3, 2, 1].map((star) => {
                        const count = summary.starDistribution?.[star] || 0;
                        const percent = summary.reviewCount ? (count / summary.reviewCount) * 100 : 0;
                        return (
                            <div key={star} className="dist-row">
                                <span className="dist-label">{star}★</span>
                                <div className="dist-bar-bg">
                                    <div className="dist-bar-fill" style={{ width: `${percent}%` }}></div>
                                </div>
                                <span className="dist-percent">{Math.round(percent)}%</span>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="top-reviews-preview">
                {summary.topReviews?.slice(0, 2).map((review, idx) => (
                    <ReviewItem key={review.reviewId || idx} review={review} />
                ))}
            </div>

            <button className="view-all-reviews-btn" onClick={onOpenAll}>
                View All Reviews <FaChevronRight className="ms-2" />
            </button>
        </div>
    );
}
